import { render, staticRenderFns } from "./chartsComponent.vue?vue&type=template&id=5a4cfcdc&scoped=true"
import script from "./chartsComponent.vue?vue&type=script&lang=js"
export * from "./chartsComponent.vue?vue&type=script&lang=js"
import style0 from "./chartsComponent.vue?vue&type=style&index=0&id=5a4cfcdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cfcdc",
  null
  
)

export default component.exports